import { Separator } from "Components/ui/separator";
import { Skeleton } from "Components/ui/skeleton";
import UseInnerWidth from "hooks/UseInnerWidth";
import React from "react";
import { useSelector } from "react-redux";

function ThirdSec() {
  const width = UseInnerWidth();

  const { getChallengeInfoLoading, getChallengesLoading, challengeInfo } =
    useSelector((state) => state.challengeMainReducer);

  return (
    <div className=" flex-1 bg-background rounded-lg p-6 border-2 border-border-darkNew flex flex-col">
      <div className="text-lg">Challenge Info</div>
      <div className="text-sm text-white-opacity font-N_Thin">
        Here's some quick useful information about your current challenge
      </div>
      <Separator className="bg-border-darkNew my-4" />
      <div
        className={`grid ${
          width < 1300
            ? width < 600
              ? "grid-cols-1"
              : "grid-cols-2"
            : "grid-cols-3"
        }  gap-6`}
      >
        <div className="flex flex-col gap-4">
          <div className="text-white-opacity text-sm">PERFORMANCE</div>
          <div className="grid grid-cols-2 gap-2">
            {getChallengesLoading || getChallengeInfoLoading ? (
              <div className="bg-transparent border-2 border-border-darkNew rounded-lg p-4 ">
                <div className="space-y-2">
                  <Skeleton className="h-7 w-[120px]" /> {/* Amount */}
                  <Skeleton className="h-4 w-[80px]" /> {/* Total P&L text */}
                </div>
              </div>
            ) : (
              <div className="p-4 border-2 border-border-darkNew rounded-lg">
                <div className="font-N_Bold text-2xl">
                  {challengeInfo?.totalProfit
                    ? challengeInfo?.totalProfit?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 3,
                      })
                    : "$0"}
                </div>
                <div className="text-white-opacity text-xs">Total P&L</div>
              </div>
            )}
            {getChallengesLoading || getChallengeInfoLoading ? (
              <div className="bg-transparent border-2 border-border-darkNew rounded-lg p-4 ">
                <div className="space-y-2">
                  <Skeleton className="h-7 w-[120px]" /> {/* Amount */}
                  <Skeleton className="h-4 w-[80px]" /> {/* Total P&L text */}
                </div>
              </div>
            ) : (
              <div className="p-4 border-2 border-border-darkNew rounded-lg">
                <div className="font-N_Bold text-2xl">
                  {" "}
                  {challengeInfo?.winRate
                    ? (challengeInfo?.winRate / 100)?.toLocaleString("en-US", {
                        style: "percent",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 3,
                      })
                    : "0%"}
                </div>
                <div className="text-white-opacity text-xs">Win Rate</div>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <div className="text-white-opacity text-sm">RULES</div>
          <div className="grid grid-cols-2 gap-2">
            {getChallengesLoading || getChallengeInfoLoading ? (
              <div className="bg-transparent border-2 border-border-darkNew rounded-lg p-4 ">
                <div className="space-y-2">
                  <Skeleton className="h-7 w-[120px]" /> {/* Amount */}
                  <Skeleton className="h-4 w-[80px]" /> {/* Total P&L text */}
                </div>
              </div>
            ) : (
              <div className="p-4 border-2 border-border-darkNew rounded-lg">
                <div className="font-N_Bold text-2xl">
                  {" "}
                  {challengeInfo?.dailyDrawdown?.drawdownValue
                    ? challengeInfo?.dailyDrawdown?.drawdownValue?.toLocaleString(
                        "en-US",
                        {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 3,
                        }
                      )
                    : "$0"}
                </div>
                <div className="text-white-opacity text-xs">Daily Drawdown</div>
              </div>
            )}
            {getChallengesLoading || getChallengeInfoLoading ? (
              <div className="bg-transparent border-2 border-border-darkNew rounded-lg p-4 ">
                <div className="space-y-2">
                  <Skeleton className="h-7 w-[120px]" /> {/* Amount */}
                  <Skeleton className="h-4 w-[80px]" /> {/* Total P&L text */}
                </div>
              </div>
            ) : (
              <div className="p-4 border-2 border-border-darkNew rounded-lg">
                <div className="font-N_Bold text-2xl">
                  {challengeInfo?.maxDrawdown?.percentage
                    ? (
                        challengeInfo?.maxDrawdown?.percentage / 100
                      )?.toLocaleString("en-US", {
                        style: "percent",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 3,
                      })
                    : "0%"}{" "}
                  <span className="font-N_Bold text-xs text-white-opacity">
                    (
                    {challengeInfo?.maxDrawdown?.rulePercentage
                      ? (
                          challengeInfo?.maxDrawdown?.rulePercentage / 100
                        )?.toLocaleString("en-US", {
                          style: "percent",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 3,
                        })
                      : "0%"}
                    )
                  </span>
                </div>
                <div className="text-white-opacity text-xs">
                  Max Drawdown Limit
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <div className="text-white-opacity text-sm">TRADES</div>
          <div className="grid grid-cols-2 gap-2">
            {getChallengesLoading || getChallengeInfoLoading ? (
              <div className="bg-transparent border-2 border-border-darkNew rounded-lg p-4 ">
                <div className="space-y-2">
                  <Skeleton className="h-7 w-[120px]" /> {/* Amount */}
                  <Skeleton className="h-4 w-[80px]" /> {/* Total P&L text */}
                </div>
              </div>
            ) : (
              <div className="p-4 border-2 border-border-darkNew rounded-lg">
                <div className="font-N_Bold text-2xl">
                  {challengeInfo?.averageDuration
                    ? challengeInfo?.averageDuration
                    : 0}
                </div>
                <div className="text-white-opacity text-xs">
                  Average Trade Duration
                </div>
              </div>
            )}
            {getChallengesLoading || getChallengeInfoLoading ? (
              <div className="bg-transparent border-2 border-border-darkNew rounded-lg p-4 ">
                <div className="space-y-2">
                  <Skeleton className="h-7 w-[120px]" /> {/* Amount */}
                  <Skeleton className="h-4 w-[80px]" /> {/* Total P&L text */}
                </div>
              </div>
            ) : (
              <div className="p-4 border-2 border-border-darkNew rounded-lg">
                <div className="font-N_Bold text-2xl">
                  {challengeInfo?.totalLots
                    ? challengeInfo?.totalLots?.toLocaleString("en-US", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 3,
                      })
                    : 0}{" "}
                  Lots
                </div>
                <div className="text-white-opacity text-xs">
                  Number Of Lots Traded
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThirdSec;
